<template>
    <div>
        <SrListItem ref="toggle" @click="emitToggle">
            <SrListItemAction class="mr-4">
                <SrCheckbox :value="allItemsSelected" />
            </SrListItemAction>
            <SrListItemContent>
                <SrListItemTitle>{{ toggleButtonText }}</SrListItemTitle>
            </SrListItemContent>
        </SrListItem>
        <VDivider />
    </div>
</template>

<script>
import { SrCheckbox } from '../SrCheckbox';
import SrListItem from '../SrListItem/SrListItem';
import SrListItemAction from '../SrListItemAction/SrListItemAction';
import SrListItemTitle from '../SrListItemTitle/SrListItemTitle';
import SrListItemContent from '../SrListItemContent/SrListItemContent';

export default {
    name: 'SrSelectToggleButton',
    components: { SrCheckbox, SrListItem, SrListItemAction, SrListItemTitle, SrListItemContent },
    props: {
        allItemsSelected: {
            type: Boolean,
            required: true,
        },
        toggleButtonText: {
            type: String,
            required: true,
        },
    },

    methods: {
        emitToggle() {
            this.$emit('toggle');
        },
    },
};
</script>
